import { Fragment, useContext } from 'react';
import { CruiseSettingContext } from '../../contexts/CruiseSettingContext';
import { Toast } from 'react-bootstrap';
import ListCruiseSetting from './ListCruiseSetting';
import AddCruiseSettingModal from './AddCruiseSettingModal';
import { ROLES, NO_PERMISSION } from '../../contexts/constants';
import { AuthContext } from '../../contexts/AuthContext';
import { useTranslation } from 'react-i18next';

const CruiseSettings = () => {
	const { t } = useTranslation();
	const {
		setShowAddCruiseSettingModal,
		showToast: { show, message, type },
		setShowToast
	} = useContext(CruiseSettingContext);

	const {
		authState: { user }
	} = useContext(AuthContext);

	if (!user) {
		return NO_PERMISSION;
	}

	if (!(user.Roles.includes(ROLES.ADMINISTRATOR) || user.Roles.includes(ROLES.SUPPER_ADMINISTRATOR))) {
		return NO_PERMISSION;
	}

	return (
		<Fragment>
			<div className='horizontal-mainwrapper container clearfix'>
				<div className='explain-dashboard mt-5'>
					<div className='explain-header mb-3'>
						<div className='row'>
							<div className='col-md-4'>
								<h3 className='pull-left'>{t('Cruise Setting List')} </h3>
							</div>
							<div className='col-md-2 ml-auto'>
								<button
									className='right-content btn btn-success btn-block'
									onClick={setShowAddCruiseSettingModal.bind(this, true)}
								>
									<i className='fe fe-plus-circle'></i>{t('Cruise Setting')}
								</button>
							</div>
						</div>
					</div>

					<ListCruiseSetting />
					<AddCruiseSettingModal />
					<Toast
						show={show}
						style={{ position: 'fixed', top: '20%', right: '10px' }}
						className={`bg-${type} text-white`}
						onClose={setShowToast.bind(this, { show: false, message: '', type: null })}
						delay={3000}
						autohide
					>
						<Toast.Body>
							<strong>{message}</strong>
						</Toast.Body>
					</Toast>
				</div>
			</div>
		</Fragment>
	);
};

export default CruiseSettings;
